// extracted by mini-css-extract-plugin
module.exports = {"component":"star-rating_component__LaUMf","star":"star-rating_star__fbv_U","halfStar":"star-rating_halfStar__oVB0f"};